import React from 'react';
import './HowToHelp.css';

const HowToHelp: React.FC = () => {
  return (
    <div className="how-to-help-page">
      <div className="container">
        <div className="page-header">
          <h1>How to Help</h1>
          <p>Every small action makes a big difference for street dogs. Here’s how you can get involved with Woofly!</p>
        </div>
        <section className="help-section">
          <div className="help-grid">
            <div className="help-card">
              <h2>🐾 Volunteer</h2>
              <p>I am not present in India so volenteers mean a lot to me Your time and energy can change lives!</p>
            </div>
            <div className="help-card">
              <h2>🍲 Donate</h2>
              <p>Support our mission by donating food, supplies, or funds to the NGOs near you. If you do not know a NgO near you we can help connect you to one. </p>
            </div>
            <div className="help-card">
              <h2>📢 Spread the Word</h2>
              <p>Share our mission on social media, tell your friends, and help us build a compassionate community. If you have a blog or a heavy Social Media presence, we would appreciate it if you could help us spread the word.</p>
            </div>
            <div className="help-card">
              <h2>💌 Contact Us</h2>
              <p>Have an idea or want to help in another way? <a href="mailto:irabhatt@gmail.com">Email us</a> and let’s chat!</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default HowToHelp; 